export const AskStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  ANSWERED: 'answered',
  ERROR: 'error',
};

export const Category = {
  GET_STARTED: 'GET_STARTED',
  MONITORING: 'MONITORING',
  OPERATIONS: 'OPERATIONS',
  ANALYTICS: 'ANALYTICS',
  MANAGEMENT: 'MANAGEMENT',
  ADMIN: 'ADMIN',
  INFORMATION: 'INFORMATION',
  OTHER: 'OTHER',
};
